module.exports = __webpack_public_path__ + "img/Group.353f09bf.png";